var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("account-verification-modal", {
        attrs: {
          "is-dialog-visible": _vm.isAccountVerificationModalVisible,
          "is-verification-override": false,
          "on-close-action": _vm.onCloseAction,
        },
        on: { visibilityChanged: _vm.setIsAccountVerificationModalVisible },
      }),
      _vm._v(" "),
      _c("account-verification-modal", {
        attrs: {
          "is-dialog-visible": _vm.isAccountVerificationOverrideModalVisible,
          "is-verification-override": true,
          "on-close-action": _vm.onCloseAction,
        },
        on: {
          visibilityChanged: _vm.setIsAccountVerificationOverrideModalVisible,
        },
      }),
      _vm._v(" "),
      _c("revoke-verification-modal", {
        attrs: { "is-dialog-visible": _vm.isAuthorizationRevokeModalVisible },
        on: { visibilityChanged: _vm.setIsAuthorizationRevokeModalVisible },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "customer-field" }, [
        _vm.isVerifyAccountButtonVisible
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "custom-el-button",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: {
                      disabled: _vm.isVerifyAccountDisabled,
                      size: "small",
                      type: "primary",
                      plain: "",
                    },
                    on: { click: _vm.showAccountVerificationModal },
                  },
                  [_vm._v("\n        Verify Account\n      ")]
                ),
                _vm._v(" "),
                _vm.isVerifyOverrideButtonVisible
                  ? _c(
                      "LinkButton",
                      {
                        attrs: { disabled: _vm.isVerifyAccountDisabled },
                        on: { click: _vm.showAccountOverrideVerificationModal },
                      },
                      [_vm._v("\n        Verify Override\n      ")]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isRevokeAuthButtonVisible
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "custom-el-button",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: {
                      slot: "reference",
                      size: "small",
                      plain: "",
                      type: "primary",
                    },
                    on: { click: _vm.showRevokeAuthorizationModal },
                    slot: "reference",
                  },
                  [_vm._v("\n        Revoke Auth\n      ")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }